// Salon-wide product selling channels — a master override that mirrors the
// gift-card equivalent (gift-cards-v2/giftCardChannels.js). When `online` is
// off, the customer storefront is hidden on the salon page and offers nothing,
// regardless of per-product `sellOnline` flags.
//
// MOCK store (localStorage) so the admin toggle and the customer-facing shop
// gate are demoable in a single browser.
//
// TODO(backend): persist on the salon record (e.g. `salon.productChannels =
// { online, pos }`) AND return it in the PUBLIC salon summary, so the shop
// (useProductShopData) and the salon page read the real value rather than this
// localStorage stand-in.
const KEY = 'beu_product_channels';
const DEFAULT = { online: true, pos: true };

export const getProductChannels = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const v = JSON.parse(raw);
      return { online: v.online !== false, pos: v.pos !== false };
    }
  } catch (e) { /* ignore malformed / blocked storage */ }
  return { ...DEFAULT };
};

export const setProductChannels = (channels) => {
  const next = { online: channels.online !== false, pos: channels.pos !== false };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* ignore */ }
  return next;
};
